import { marketBaseOf } from "@local/i18n/src/languages"
import { CartManager } from "./CartState"

/**
 * Global registry to store CartManager instances by region+channel key
 * This ensures we reuse the same instance across all components
 */
export const cartManagerRegistry = new Map<string, CartManager>()

/**
 * Gets or creates a CartManager instance for the given region and channel
 * @param region - The region identifier
 * @param channel - The channel identifier
 * @returns Shared CartManager instance
 *
 * DEV-9850: the cart is a MARKET-level identity — one cart per market,
 * independent of the render language. A public language-variant slug
 * ("de-en") must resolve to the SAME manager as its base market ("de");
 * otherwise /de-en gets its own empty cart and checkout wrongly falls through
 * to the free-order flow. Key the in-memory registry by the base market so it
 * matches the base-market storage key `CartManager`/`CartStorage` use.
 */
export const getOrCreateCartManager = (
  region: string,
  channel: string
): CartManager => {
  const baseRegion = marketBaseOf(region)
  const key = `${baseRegion}_${channel}`

  if (!cartManagerRegistry.has(key)) {
    cartManagerRegistry.set(key, new CartManager(baseRegion, channel))
  }

  return cartManagerRegistry.get(key)!
}
